function setRInputBarValue(element, value) {
  let rInputBar = element.closest('.card__content').querySelector('.Rd-input-bar');
  if (rInputBar) {
    rInputBar.value = value;
  }
}


window.selectQtY = async (e) => {
  try {
    let selectedValue = e.value;
    let options = e.options;
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].setAttribute("selected", "selected");
      } else {
        options[i].removeAttribute("selected");
      }
    }
    setRInputBarValue(e, selectedValue);
  } catch (error) {
    console.error("An error occurred:", error);
  }
}



window.selectSizes = async (e) => {
  try {
     let maxQty_card = parseInt(e.parentElement.querySelector("input").getAttribute('QTY'));
if (maxQty_card > 20) {
    maxQty_card = 20;
} else{maxQty_card}
    if (e.closest('.product__varient__container').querySelector('input').getAttribute('qty') == '0') return;
    e.closest('.card__content').querySelector('.st-collection_qty_container').innerHTML = "";
    for (let i = 1; i <= maxQty_card; i++){
      e.closest('.card__content').querySelector('.st-collection_qty_container').innerHTML += `<option value="${i}" ${i === 1 ? selected="selected" : ''}>Quantity - ${i}</option>`
    }
    let rVarIDBar = e.closest('.card__content').querySelector('.product-variant-id');
    if (rVarIDBar) {
      rVarIDBar.value = e.closest('.product__varient__container').querySelector('input').getAttribute('vatiant')
    }
    setRInputBarValue(e, e.value);
    // SetAtcInputBtn(e, e.value)
  } catch (error) {
    console.error("An error occurred:", error);
  }
}


window.initializeSlider = function() {
  try {
    if (screen.width > 786) {
      const slider = document.querySelectorAll('variant-radios1 .scroll-offer');
      let isDown = false;
      let startX;
      let scrollLeft;
      
      for (let i = 0; i < slider.length; i++) {
        slider[i].addEventListener('mousedown', (e) => {
          isDown = true;
          slider[i].classList.add('active');
          startX = e.pageX - slider[i].offsetLeft;
          scrollLeft = slider[i].scrollLeft;
        });
        
        slider[i].addEventListener('mouseleave', () => {
          isDown = false;
          slider[i].classList.remove('active');
        });
        
        slider[i].addEventListener('mouseup', () => {
          isDown = false;
          slider[i].classList.remove('active');
        });
        
        slider[i].addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider[i].offsetLeft;
          const walk = (x - startX) * 3; //scroll-fast
          slider[i].scrollLeft = scrollLeft - walk;
        });
      }
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}

// Call the function to initialize the slider
initializeSlider();

